import { Instance, types } from "mobx-state-tree";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { MessageTag } from "@fidget/common/models/messageTag";
import { AnyUserReferenceType } from "../../../users/AnyUserReferenceType";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";

/**
 *  Notification about events related to chat users (assignment, following).
 *  Its text content will update with users (eg. after fully fetching the profiles).
 *  TODO: `subtype` should have its own type
 */
export const UserEventChatItem = types
  .compose(
    "UserEventChatItem",
    BaseChatItem,
    types.model({
      type: types.literal(ChatItemType.UserEvent),
      subtype: types.enumeration<MessageTag>("UserEventSubtype", Object.values(MessageTag)),
      subject: AnyUserReferenceType,
      actor: types.maybe(AnyUserReferenceType)
    })
  )
  .views((self) => ({
    get text() {
      const params = self.actor?.isAgent
        ? { count: 2, user1: self.subject.displayedName, user2: self.actor.displayedName }
        : { count: 1, user1: self.subject.displayedName };

      if (self.subtype === MessageTag.ASSIGNEE_CHANGED) {
        return intl.formatMessage("conversation.event.assigneeChanged", params);
      } else if (self.subtype === MessageTag.FOLLOWER_ADDED) {
        if (self.actor === self.subject) {
          return intl.formatMessage("conversation.event.startedFollowing", {
            name: self.subject.displayedName
          });
        } else {
          return intl.formatMessage("conversation.event.followerAdded", params);
        }
      } else if (self.subtype === MessageTag.FOLLOWER_REMOVED) {
        if (self.actor === self.subject) {
          return intl.formatMessage("conversation.event.stoppedFollowing", {
            name: self.subject.displayedName
          });
        } else {
          return intl.formatMessage("conversation.event.followerRemoved", params);
        }
      } else if (self.subtype === MessageTag.ASSIGNEE_REMOVED) {
        return intl.formatMessage("conversation.event.assigneeRemoved", {
          name: self.subject.displayedName
        });
      }
      // TODO: handle unknown subtype
      return "";
    }
  }));

export interface IUserEventChatItem extends Instance<typeof UserEventChatItem> {}
